import { render, staticRenderFns } from "./CandidateInfo.vue?vue&type=template&id=666c0a5d&"
import script from "./CandidateInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormElement: require('/home/vsts/work/1/s/components/FormElement.vue').default})
